var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('head-view'),_vm._v(" "),_c('Row',[_c('Col',{attrs:{"span":"4"}},[_c('menus-view')],1),_vm._v(" "),_c('Col',{attrs:{"span":"20"}},[_c('router-view',{staticClass:"xbed-oms-content"})],1)],1),_vm._v(" "),_c('foot-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4320f3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":true}!./src/pages/main.vue
// module id = Fj3X
// module chunks = 0